import { groq } from 'next-sanity'

export const fields = groq`
  title,
  "slug": slug.current
`

export const fragment = (name = 'lifestyleCategory') => `${name}{ ${fields} }`

const exports = { fields, fragment }

export default exports
